/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./action-bar.vue?vue&type=template&id=08708208&scoped=true&"
import script from "./action-bar.vue?vue&type=script&lang=js&"
export * from "./action-bar.vue?vue&type=script&lang=js&"
import style0 from "./action-bar.vue?vue&type=style&index=0&id=08708208&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08708208",
  null
  
)

export default component.exports